import './src/styles/global.css';

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  // Check if this navigation was from a text fragment link
  const isTextFragmentNav = typeof window !== 'undefined' && 
    sessionStorage.getItem('isTextFragmentNavigation') === 'true';
  
  sessionStorage.removeItem('isTextFragmentNavigation');

  if (isTextFragmentNav) {
    // Clear the flag
    return false;
  }
  
  return true;
};